/** Map WorkOS auth error code to Japanese title + message for login error banner. */
const WORKOS_ERROR_MESSAGES_JP = {
    domain_not_allowed:
        'このメールドメインは許可されていません。有効なメールアドレスでログインしてください。',
    domain_whitelist_not_configured:
        'メールドメインの設定が未構成です。管理者にお問い合わせください。',
    invalid_state: 'セッションが無効です。再度ログインを試してください。',
    invalid_client: 'クライアント情報が無効です。',
    missing_params: '認証パラメータが不足しています。再度お試しください。',
    exchange_failed: '認証の処理に失敗しました。再度お試しください。',
    no_email: 'メールアドレスを取得できませんでした。',
    invalid_email_domain: 'メールアドレスの形式が無効です。',
    organization_not_configured: '組織が設定されていません。管理者にお問い合わせください。',
    org_fetch_failed: '組織情報の取得に失敗しました。しばらくしてから再度お試しください。',
    admin_not_found: '管理者アカウントが見つかりません。',
    admin_login_failed: '管理者ログインに失敗しました。',
    user_invite_limit: 'ユーザー数の上限に達しています。管理者にお問い合わせください。',
    user_creation_failed: 'ユーザー作成に失敗しました。',
    login_denied: 'ログインの権限がありません。',
    user_login_failed: 'ログインに失敗しました。',
    sso_disabled: 'SSOが無効です。管理者にお問い合わせください。',
    social_login_disabled: 'ソーシャルログインが無効です。管理者にお問い合わせください。',
    microsoft_login_unavailable:
        'Microsoftログインが利用できません。管理者にお問い合わせください。',
    microsoft_auth_network:
        'Microsoftへの接続に失敗しました。ネットワークを確認し、再度お試しください。',
    microsoft_token_http_error:
        'Microsoftとの認証処理に失敗しました。設定を確認するか、しばらくしてから再度お試しください。',
    microsoft_token_rejected:
        'Microsoft側でログインを完了できませんでした（コードの期限切れなど）。最初からやり直してください。',
    microsoft_no_valid_email:
        'Microsoftアカウントから有効なメールアドレスを取得できませんでした。管理者にお問い合わせください。',
    microsoft_nonce_mismatch:
        'ログインセッションが無効です。最初からMicrosoftログインをやり直してください。',
    microsoft_sign_in_cancelled: 'Microsoftログインがキャンセルされたか、完了しませんでした。',
    organization_invalid: '組織の設定がまだ完了していません。管理者までご連絡ください。',
};
const WORKOS_ERROR_TITLE_JP = 'ログインできません';
const WORKOS_ERROR_FALLBACK_JP = 'ログインできません。しばらくしてから再度お試しください。';

export { WORKOS_ERROR_MESSAGES_JP, WORKOS_ERROR_TITLE_JP, WORKOS_ERROR_FALLBACK_JP };
